import BlankBill from "../blankProviderBill";
import { connect } from "react-redux";
import React, { Component } from "react";
import TableBill from "../../table/table-bill-provider";
import {
  getProviderBills,
  clearBillsList,
} from "../../../../Redux/actions/billActions";
import {
  getProviderBills as getBillsProvider,
  getTotalElements,
} from "../../../../Redux/reducer/bills";

export class ByStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      sizePerPage: 10,
      filters: [
        {
          property: "status",
          operator: "in",
          value:
            "APPROVED,VALIDATED,ACCEPTED_PARTIALLY,ACCEPTED,PROCESSED,PAID,REJECTED,CANCELLED",
        },
      ],
      byStatus: "",
      componentReady: false,
    };
  }

  componentDidMount() {
    this.props.updateAlert();
    return this.loadBills();
  }

  componentDidUpdate() {
    var customFilters = this.getFilters();
    if (JSON.stringify(customFilters) !== JSON.stringify(this.state.filters)) {
      this.setState({ filters: customFilters });
      this.loadBills();
    }
    // if (this.props.byStatus !== this.state.byStatus) {
    //   this.setState({ byStatus: this.props.byStatus });
    //   this.loadBills();
    // }
  }

  componentWillUnmount() {
    this.props.clearBillsList();
    this.props.setModal(true);
    this.props.updateAlert();
  }

  loadBills() {
    var customFilters = this.getFilters();
    return this.props
      .getProviderBills(this.state.page, this.state.sizePerPage, customFilters)
      .then(() => {
        this.props.setModal(false);
        this.setState({ componentReady: true, filters: customFilters });
      });
  }

  getFilters() {
    var customFilters = [...this.state.filters];
    if (this.props.byStatus !== "") {
      customFilters = [...this.props.filters];
      // if (this.props.byStatus !== '' && this.state.byStatus !== this.props.byStatus) {
      let opertator = "eq";
      if (this.props.byStatus.split(",").length > 1) {
        opertator = "in";
      }
      customFilters.push({
        property: "status",
        operator: opertator,
        value: this.props.byStatus,
      });
    }

    return customFilters;
  }

  getBillsHandler = (page, sizePerPage, paramfilters, sortFilter) => {
    this.props.setModal(true);
    return this.props
      .getProviderBills(page, sizePerPage, paramfilters, sortFilter)
      .then(() => {
        this.setState({ page: page, sizePerPage: sizePerPage });
        this.props.setModal(false);
      });
  };

  render() {
    const { componentReady, page, sizePerPage, filters } = this.state;
    const { bills, totalElements, updateCreditLine } = this.props;

    return componentReady ? (
      bills.length > 0 ? (
        <TableBill
          data={bills}
          page={page}
          getProviderBills={this.getBillsHandler}
          totalSize={totalElements}
          sizePerPage={sizePerPage}
          filters={filters}
          updateCreditLine={updateCreditLine}
          approvedTo={`PENDING`}
          mode="by-status"
          needActions={false}
        />
      ) : (
        <BlankBill />
      )
    ) : null;
  }
}

export const mapStateToProps = (state) => {
  return {
    bills: getBillsProvider(state),
    totalElements: getTotalElements(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    getProviderBills: (page, size, filters, sort) =>
      dispatch(getProviderBills(page, size, filters, sort)),
    clearBillsList: (payload) => dispatch(clearBillsList(payload)),
  };
};

export default connect(mapStateToProps, mapDispatch)(ByStatus);
